import { render } from "./formArea.vue?vue&type=template&id=09f7a936&ts=true"
import script from "./formArea.vue?vue&type=script&lang=ts"
export * from "./formArea.vue?vue&type=script&lang=ts"

import "./formArea.vue?vue&type=style&index=0&id=09f7a936&lang=less"

import exportComponent from "C:\\code\\webapp\\postcard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__